import "./Button.css"


export default function NavigationButton({titulo, path}){
    return (
        <a href={path} style={{ textDecoration: "none" }}>
            <button className={"Button-Style"}>
                {titulo}
            </button>
        </a>
    );
}